module.exports = __webpack_public_path__ + "modules/platform/img/banner-demo1.png";